//patch 一个方法劫持
export const patchMethod = (obj, key, patchFn) => {
    return (...params) => {
        // eslint-disable-next-line no-param-reassign
        obj[key] = patchFn(obj[key], ...params);
    };
};
